var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#747474;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.127 0.442)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.193 -0.377)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 48,
    height: 48,
    transform: "translate(-0.065 -0.066)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.819 1.641)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 7,
    height: 14,
    transform: "translate(3.308 17.917)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6.023,
    height: 14.054,
    transform: "translate(17.191 18.069)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 40,
    height: 6,
    transform: "translate(0.308 35.917)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 7,
    height: 14,
    transform: "translate(30.308 17.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.077,1,2,11.038v4.015H42.154V11.038Z",
    transform: "translate(-1.874 -1)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchLogo);
export default __webpack_public_path__ + "static/media/ach-logo.35d70dbf7db350c289611157158de9ea.svg";
export { ForwardRef as ReactComponent };